import translationEN from '../locales/en/translation.json';
import translationFR from '../locales/fr/translation.json';
import translationSV from '../locales/sv/translation.json';
import translationPT from '../locales/pt/translation.json';


// the translations
export const resources = {
  fr: {
    translation: translationFR
  },
  en: {
    translation: translationEN
  },
  sv:{
    translation: translationSV
  },
  pt:{
    translation:translationPT
  }
};
